module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "direct-chat-msg",
    class: _vm.isMine ? '' : 'right'
  }, [_c('div', {
    staticClass: "direct-chat-info clearfix"
  }, [_c('span', {
    staticClass: "direct-chat-name",
    class: _vm.isMine ? 'pull-right' : 'pull-left'
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticClass: "direct-chat-timestamp pull-right",
    class: _vm.isMine ? 'pull-left' : 'pull-right'
  }, [_vm._v(_vm._s(_vm.parseDate))])]), _vm._v(" "), _c('img', {
    staticClass: "direct-chat-img",
    attrs: {
      "src": _vm.profileImage,
      "alt": "message user image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "direct-chat-text"
  }, [_vm._v("\n    " + _vm._s(_vm.message) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ff45446!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VADirectChatItem.vue
// module id = 528
// module chunks = 1